import { socialLinks } from "../constants";
import KeepItFunBottomBGElement from "../../components/Icons/TeamAndCulture/OurValues/KeepItFunBottomBGElement";
import KeepItFunTopBGElement from "../../components/Icons/TeamAndCulture/OurValues/KeepItFunTopBGElement";
import LearnEveryDayBottomBGElement from "../../components/Icons/TeamAndCulture/OurValues/LearnEveryDayBottomBGElement";
import LearnEveryDayTopBGElement from "../../components/Icons/TeamAndCulture/OurValues/LearnEveryDayTopBGElement";
import OwnItUpBottomBGElement from "../../components/Icons/TeamAndCulture/OurValues/OwnItUpBottomBGElement";
import OwnItUpTopBGElement from "../../components/Icons/TeamAndCulture/OurValues/OwnItUpTopBGElement";

const ourJourney = [
  {
    title: "We Started",
    date: "Aug 2020",
    description: "Started with one crazy mission: “Make Learning Fun & Easy”",
    image: "/assets/teams/our-journey/our-journey-1.webp",
  },
  {
    title: "App Launch",
    date: "Aug 2020",
    description: "Launched our very first app from a small room in Udaipur",
    image: "/assets/teams/our-journey/our-journey-2.webp",
  },
  {
    title: "Moved to Bengaluru",
    date: "Nov 2022",
    description:
      "Shifted base from the calm of Udaipur to the hustle of Bengaluru",
    image: "/assets/teams/our-journey/our-journey-3.webp",
  },
  {
    title: "First Multi-Million Dollar Funding",
    date: "Mar 2023",
    description: "Earned our first fund cheque of 3M$ from Elevation Capital",
    image: "/assets/teams/our-journey/our-journey-4.webp",
  },
  {
    title: "Our New Office",
    date: "Jun 2023",
    description:
      "Finally got an office. Goodbye rooms, hello desks & big ideas",
    image: "/assets/teams/our-journey/our-journey-5.webp",
  },
  {
    title: "1 Million Strong",
    date: "Oct 2024",
    description: "Hit 1M paid users. Mom finally said, “Good Job Beta”",
    image: "/assets/teams/our-journey/our-journey-6.webp",
  },
  {
    title: "Series A Funding",
    date: "Nov 2024",
    description:
      "$8M Series A from Lightspeed. Mission validated, vibes lifted",
    image: "/assets/teams/our-journey/our-journey-7.webp",
  },
  {
    title: "4 Million Paid Subscribers",
    date: "Jul 2025",
    description:
      "4M Subscribers Strong. Fueled by user love, driven to give back",
    image: "/assets/teams/our-journey/our-journey-8.webp",
  },
  {
    title: "Series B Funding",
    date: "Sep 2025",
    description: "Series B of 28M$ raised. Fueling the next crazy chapter",
    image: "/assets/teams/our-journey/our-journey-9.webp",
  },
  {
    title: "Now",
    date: "Now",
    description: "Now it's your turn. Join the journey or watch it fly",
    image: "/assets/teams/our-journey/our-journey-last.webp",
  },
];

const ourValues = [
  {
    title: "Keep it Fun",
    desc: "Work should energize, not drain. We celebrate all wins, spread positivity, and make the journey as rewarding as the goal",
    icon: "/assets/teams/our-values/keep-it-fun.webp",
    bgColor: "#302705",
    borderColor: "#6f6850",
    bgTopElement: <KeepItFunTopBGElement />,
    bgBottomElement: <KeepItFunBottomBGElement />,
  },
  {
    title: "Own it Up",
    desc: "We take responsibility, not just tasks. Every challenge, project, and outcome is ours, creating lasting impact",
    icon: "/assets/teams/our-values/own-it-up.webp",
    bgColor: "#1b062e",
    borderColor: "#472f5d",
    bgTopElement: <OwnItUpTopBGElement />,
    bgBottomElement: <OwnItUpBottomBGElement />,
  },
  {
    title: "Learn Every Day",
    desc: "Curiosity fuels growth. Learning daily from teammates, users, and the world, we grow individually and together, constantly leveling up",
    icon: "/assets/teams/our-values/learn-every-day.webp",
    bgColor: "#0d2c05",
    borderColor: "#557050",
    bgTopElement: <LearnEveryDayTopBGElement />,
    bgBottomElement: <LearnEveryDayBottomBGElement />,
  },
];

const lifeAtSeekho = [
  {
    title: "Weekly<br/>Coffee",
    desc: "Random coffee pairings = instant buddies, zero small talk, solid connects",
    icon: "/assets/teams/life-at-seekho/weekly-coffee.webp",
  },
  {
    title: "Monthly Team Dinners",
    desc: "A team that grinds together, dines together. Work hard, party harder",
    icon: "/assets/teams/life-at-seekho/monthly-team-dinner.webp",
  },
  {
    title: "Quarterly Team Trips",
    desc: "Our offsites go global: Langkawi last year, maybe Europe with us next?",
    icon: "/assets/teams/life-at-seekho/quarterly-team-trips.webp",
  },
  {
    title: "Clubs &<br/>Activities",
    desc: "Football with CEO, cricket with CTO, weekly runs with team, book clubs & more",
    icon: "/assets/teams/life-at-seekho/clubs-and-activities.webp",
  },
  {
    title: "Daily Lunch & Snacks",
    desc: "Vending machine full of snacks or your favourite meals, we got you",
    icon: "/assets/teams/life-at-seekho/daily-lunch-and-snacks.webp",
  },
  {
    title: "We Celebrate Together",
    desc: "Birthdays = leave + cake + parties you won't forget",
    icon: "/assets/teams/life-at-seekho/we-celebrate-together.webp",
  },
  {
    title: "Weekly Appreciation",
    desc: "Because recognition > Monday blues. Btw be ready for the feedback, JK :)",
    icon: "/assets/teams/life-at-seekho/weekly-appreciation.webp",
  },
];

const employeeWellBeing = [
  {
    title: "Health & Insurance",
    desc: "Comprehensive medical, dental, and mental health coverage for you and your family",
    icon: "/assets/teams/well-being/health-insurance.webp",
  },
  {
    title: "Learning Allowance",
    desc: "Annual budget for courses, certifications, books, and skill growth",
    icon: "/assets/teams/well-being/learning-allowances.webp",
  },
  {
    title: "Paid Conferences",
    desc: "Company-sponsored conferences, workshops, and networking to grow your expertise",
    icon: "/assets/teams/well-being/paid-conferences.webp",
  },
];

const peopleOfSeekho = [
  // {
  //   name: "Anjum Afreen",
  //   designation: "Manager - Human Resources",
  //   image: "/assets/teams/people-of-seekho/anjum-afreen.webp",
  //   desc: "",
  // },
  {
    name: "Sneha Dutta",
    designation: "Senior Content Associate",
    image: "/assets/teams/people-of-seekho/sneha-dutta.webp",
    desc: "I'm free to experiment and learn from failures. With a userfirst mindset, I keep growing because here, growth begins where comfort ends.",
  },
  // {
  //   name: "Mukesh Eswaran",
  //   designation: "Senior Business Analyst",
  //   image: "/assets/teams/people-of-seekho/mukesh-eswaran.webp",
  //   desc: "",
  // },
  {
    name: "Abrar Khan",
    designation: "Software Developer II",
    image: "/assets/teams/people-of-seekho/ak.webp",
    desc: "Every idea is valued, and the culture of growth, ownership, and passion inspires me to improve daily, take responsibility, and make a lasting impact.",
  },
  {
    name: "Karan Gala",
    designation: "Director - Growth & Marketing",
    image: "/assets/teams/people-of-seekho/karan-gala.webp",
    desc: "At Seekho, purpose meets people. With ownership, challenges, and fun, I grow every day while building something meaningful with an amazing team.",
  },
  {
    name: "Manmeet Singh",
    designation: "Senior Manager, Content Moderation",
    image: "/assets/teams/people-of-seekho/manmeet-singh-raina.webp",
    desc: "I've explored new areas, learned tech & backend systems, and built ideas from scratch turning them into impact with a supportive team.",
  },
  // {
  //   name: "Anisha Sinha",
  //   designation: "Social Media Associate",
  //   image: "/assets/teams/people-of-seekho/anisha-sinha.webp",
  //   desc: "",
  // },
  // {
  //   name: "Anil Kumar",
  //   designation: "Business Associate",
  //   image: "/assets/teams/people-of-seekho/anil-saran.webp",
  //   desc: "",
  // },
  // {
  //   name: "Kumari Jyoti",
  //   designation: "Manager, Finance & Accounts",
  //   image: "/assets/teams/people-of-seekho/jyoti-sharma.webp",
  //   desc: "",
  // },
  {
    name: "Prince",
    designation: "Software Developer II",
    image: "/assets/teams/people-of-seekho/prince-patoliya.webp",
    desc: "Seekho feels like college: freedom to explore, real ownership, and a fun culture where mistakes turn into lessons and milestones into celebrations.",
  },
];

const hiringGoogleForm =
  "https://docs.google.com/forms/d/e/1FAIpQLSe3Pd0gwXyTqhgqjaDtfNcUkEf0ASeZTTn_uVj_VOYCPAMyVw/viewform";
const lifeAtSeekhoVideo =
  "https://www.youtube.com/embed/VH5C3JHawWA?autoplay=1&mute=1&loop=1&playlist=VH5C3JHawWA&rel=0&controls=1";

const teamStructureData = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  mainEntity: {
    "@type": "Organization",
    name: "Seekho",
    url: "https://seekho.in/",
    logo: "https://images.seekhoapp.com/static/website/seekho-logo-website-v1.png",
    sameAs: [
      socialLinks.facebook,
      socialLinks.linkedIn,
      socialLinks.instagram,
      socialLinks.youtube,
      socialLinks.x,
    ],
    description:
      "At Seekho, our team comprises diverse experts driven by collaboration, innovation, and purpose. Discover the people and culture behind Seekho.",
    founder: {
      "@type": "Person",
      name: "Rohit Choudhary",
    },
  },
  headline: "Seekho Team & Culture",
  description:
    "Meet the Seekho team and explore our culture of collaboration, diversity, and innovation. Learn more about the people who power Seekho.",
};

const ourFounderStory = [
  `The Seekho story begins with three friends who've known each
  other for over 12 years. Rohit and Keertay first met while
  preparing for India’s most competitive engineering entrance
  exam, later reuniting with Yash at IIT Kanpur, where they lived in
  the same hostel. Their complementary skills emerged through years
  of collaboration: Rohit’s product intuition, Keertay’s
  content expertise, and Yash’s technical prowess.`,

  `Their breakthrough insight came while working at KukuFM. They
  noticed millions of Indians consuming audio content in regional
  languages but struggling to find practical, skill-based education.`,

  `“At Seekho, our mission is to make learning fun and easy for
  everyone regardless of language, location, or background,” says
  Rohit. “We believe learning should be relevant, bite-sized, and
  accessible in the palm of your hand.”`,
];

const ourRatingsAndReviewsData = [
  {
    title: "Glassdoor",
    image: "/assets/teams/our-ratings-and-reviews/glassdoor-logo.webp",
    url: "https://www.glassdoor.co.in/Overview/Working-at-Seekho-EI_IE8540714.11,17.htm",
  },
  {
    title: "Ambitionbox",
    image: "/assets/teams/our-ratings-and-reviews/ambitionbox-logo.webp",
    url: "https://www.ambitionbox.com/overview/seekho-overview",
  },
];

export {
  ourJourney,
  ourValues,
  lifeAtSeekho,
  employeeWellBeing,
  peopleOfSeekho,
  hiringGoogleForm,
  lifeAtSeekhoVideo,
  teamStructureData,
  ourFounderStory,
  ourRatingsAndReviewsData,
};
